var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_976",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.499023,
    y: 0.0078125,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_2",
    d: "M11.799 19.3086C11.6157 19.1253 11.5199 18.8919 11.5115 18.6086C11.5032 18.3253 11.5907 18.0919 11.774 17.9086L16.674 13.0086H5.49902C5.21569 13.0086 4.97819 12.9128 4.78652 12.7211C4.59486 12.5294 4.49902 12.2919 4.49902 12.0086C4.49902 11.7253 4.59486 11.4878 4.78652 11.2961C4.97819 11.1044 5.21569 11.0086 5.49902 11.0086H16.674L11.774 6.10859C11.5907 5.92526 11.5032 5.69193 11.5115 5.40859C11.5199 5.12526 11.6157 4.89193 11.799 4.70859C11.9824 4.52526 12.2157 4.43359 12.499 4.43359C12.7824 4.43359 13.0157 4.52526 13.199 4.70859L19.799 11.3086C19.899 11.3919 19.9699 11.4961 20.0115 11.6211C20.0532 11.7461 20.074 11.8753 20.074 12.0086C20.074 12.1419 20.0532 12.2669 20.0115 12.3836C19.9699 12.5003 19.899 12.6086 19.799 12.7086L13.199 19.3086C13.0157 19.4919 12.7824 19.5836 12.499 19.5836C12.2157 19.5836 11.9824 19.4919 11.799 19.3086Z",
    fill: "#00A693"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow_forward.c385c5c55e3ad0ca1ab26be1b91296da.svg";
export { ForwardRef as ReactComponent };